import { Injectable } from "@angular/core";

import { parseList } from "@helpers/functions";
import { SocketService } from "../socket.service";
import { CryptoTransactionNotifyService } from "../notify/crypto_transaction.notify.service";
import { InitService } from "@core-services/init.service";
import { ServiceNames } from "@models/service_enums";
import { DerivativeWalletService } from "./derivative_wallet.service";
import { EtfWallet } from "@models/derivative/wallets/etf_wallet";
import { Etf } from "@models/derivative/currencies/etf";
import { ETF_TRANSACTIONS_ROOM, ETF_WALLETS_ROOM } from "@helpers/constants";
import { EtfService } from "../currency/etf.service";
import { DerivativeTransaction } from "@models/transaction";
import { GetPendingTradesGQLService } from "@gql/offer";
import { ApicallService } from "@core-services/apicall.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";

const name = ServiceNames.ETF_WALLET;

@Injectable({
	providedIn: "root"
})
export class EtfWalletService extends DerivativeWalletService<EtfWallet, Etf> {
	public name: string = ServiceNames.ETF_WALLET;

	public TxType = DerivativeTransaction;
	public WalletType = EtfWallet;

	protected transactionSocketRoomName: string = ETF_TRANSACTIONS_ROOM;
	protected walletSocketRoomName: string = ETF_WALLETS_ROOM;

	public constructor(
		protected currencyService: EtfService,
		protected apicallService: ApicallService,
		protected infoService: InfoService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected initService: InitService,
		protected transactionNotifyService: CryptoTransactionNotifyService,
		protected destructor: DestructorService,
		protected getPendingTradesGQLService: GetPendingTradesGQLService
	) {
		super(initService, destructor, name, getPendingTradesGQLService);
	}

	public getCanCreateMore(): boolean {
		return this.canCreateMore;
	}

	public getCannotCreateReason(): string {
		return this.cannotCreateReason;
	}

	public getParseData(wallets): EtfWallet[] {
		if (!wallets || !wallets["attributes"]["etfs"]) {
			return [];
		}
		return parseList(wallets["attributes"]["etfs"]["attributes"]["wallets"], EtfWallet);
	}
}
